/**
 * Sort filter definitions to match current table column order.
 *
 * @param filters — array of filter items with at least `id` (and optionally `type`)
 * @param columns — current column order (array with `id` field)
 * @param filterIdToColumnId — mapping from filter section ID to table column ID
 * @param pinnedTypes — optional config for types that should be pinned first/last
 */
export function sortFiltersByColumnOrder<
  F extends { id: string; type?: string },
  C extends { id: string },
>(
  filters: F[],
  columns: C[],
  filterIdToColumnId: Record<string, string>,
  pinnedTypes?: { first?: string; last?: string },
): F[] {
  const columnIndexMap = new Map(columns.map((col, idx) => [col.id, idx]));
  return [...filters].sort((a, b) => {
    if (pinnedTypes) {
      if (a.type === pinnedTypes.first) return -1;
      if (b.type === pinnedTypes.first) return 1;
      if (a.type === pinnedTypes.last) return 1;
      if (b.type === pinnedTypes.last) return -1;
    }
    const colA = filterIdToColumnId[a.id];
    const colB = filterIdToColumnId[b.id];
    const idxA = colA != null ? (columnIndexMap.get(colA) ?? Infinity) : Infinity;
    const idxB = colB != null ? (columnIndexMap.get(colB) ?? Infinity) : Infinity;
    return idxA - idxB;
  });
}
